import {
  NetworkError,
  ValidationError,
  errorFromResponse,
} from "./errors.js";
import { log } from "../utils/logger.js";

async function jsonRequest(url, init) {
  let response;
  try {
    response = await fetch(url, {
      ...init,
      credentials: "include",
      headers: { "Content-Type": "application/json", ...(init?.headers || {}) },
    });
  } catch (err) {
    log.error("feedbackClient: network failure", { url, err: String(err) });
    throw new NetworkError(`Failed to reach ${url}`, err);
  }
  if (!response.ok) throw await errorFromResponse(response);
  if (response.status === 204) return null;
  try {
    return await response.json();
  } catch (err) {
    throw new NetworkError(`Malformed JSON from ${url}`, err);
  }
}

/**
 * Build the client-owned portion of a feedback request. Identity fields are
 * deliberately not accepted here: the server stamps author and role from the
 * authenticated request.
 */
export function buildFeedbackPayload({
  type,
  severity,
  body,
  pageRoute = null,
  recordRef = null,
  appBuild = null,
  viewport = null,
} = {}) {
  if (type !== "bug" && type !== "data_error" && type !== "idea") {
    throw new ValidationError("Feedback type must be bug, data_error, or idea");
  }
  if (typeof body !== "string" || !body.trim()) {
    throw new ValidationError("Feedback details are required");
  }
  const payload = {
    type,
    body: body.trim(),
    page_route: pageRoute || null,
    record_ref: recordRef || null,
    app_build: appBuild || null,
    viewport: viewport || null,
  };
  if (type === "bug") payload.severity = severity || "annoying";
  else if (type === "idea") payload.severity = null;
  return payload;
}

export async function submitFeedback(payload) {
  return jsonRequest("/api/feedback", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}